module.exports = __webpack_public_path__ + "img/coming-soon.9e706951.svg";